var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FileUpload',{attrs:{"fileName":_vm.fileName,"dropOptions":_vm.options,"enableFileUpload":!_vm.disabled},on:{"file-add-complete":_vm.onFileAddComplete,"fileupload-error":function($event){return _vm.$emit('file-upload-error', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }